import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import dayjs from 'dayjs';

import formatCurrency from 'format-currency';
import DsImage from '../../ds/atoms/image/Image';
import { getLangValue } from '../../../utils/Generic';
import '../../../static/less/budget/budget.less';

const BudgetCart = ({
  cart, hotel, lastRequestedInfo, cartRoom, lang, paymentMethod,
}, context) => {
  const hasRooms = Boolean(cartRoom && cartRoom.room);
  const hasHotelPhotos = hotel && hotel.photos != null;
  const checkIn = dayjs(lastRequestedInfo.checkin || lastRequestedInfo.check_in).format('DD/MM/YYYY');
  const checkOut = dayjs(lastRequestedInfo.checkout || lastRequestedInfo.check_out).format('DD/MM/YYYY');
  const paymentCurrency = cart.cartHotel.currency;
  const currentAmount = cart.amount[paymentCurrency.code];
  let adults = 0;
  let children = 0;
  let infants = 0;
  cart.cartHotel.rooms.forEach((room) => {
    adults += room.distribution.adults;
    children += room.distribution.children;
    infants += room.distribution.infants;
  });

  let guests = context.t(['1 Adult', '{n} Adults'], { n: adults });
  if (children && children > 0) {
    guests = `${context.t(['1 Adult', '{n} Adults'], { n: adults })} + ${
      context.t(['1 Child', '{n} Children'], { n: children })}`;
  }
  if (infants && infants > 0) {
    guests = `${context.t(['1 Adult', '{n} Adults'], { n: adults })} + ${
      context.t(['1 Child', '{n} Children'], { n: children })} + ${
      context.t(['1 Infant', '{n} Infants'], { n: infants })}`;
  }

  return (
          <div className="BudgetShareCart px-1 py-2">
            {hasRooms && <div>

              {hasHotelPhotos && <div className="flex">
                <figure className="w-full">
                  <DsImage img={hotel.photos[0].url}
                           width={500} height={250} alt="hotel"
                           className="min-h-full object-cover"/>
                </figure>
              </div>}
              <div className="flex">
                <div className="font-bold py-1">
                  {context.t('Saved on')}: {dayjs().format('DD/MM/YYYY')}
                </div>
              </div>
              <div className="flex">
                <div className="w-1/2">
                  <div className="font-bold py-1">
                    {context.t('Check  In')}: {checkIn}
                  </div>
                  <div className="font-bold py-1">
                    {context.t('Rooms')}: {Object.keys(hotel.rooms).length}
                  </div>
                </div>
                <div className="w-1/2">
                  <div className="font-bold py-1">
                    {context.t('Check Out')}: {checkOut}
                  </div>
                  <div className="font-bold py-1">
                    {context.t('Guests')}: {guests}
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="font-bold py-1">
                  {context.t('Rate')}: {getLangValue(cartRoom.rate, lang, 'name')} / {getLangValue(cartRoom.board, lang, 'name')}
                </div>
              </div>
              <div className="flex">
                <div className="font-bold py-1">
                  {context.t('Fee')}: {getLangValue(paymentMethod.value, lang, 'name')}
                </div>
              </div>
              <div className="flex w-full">
                <div className={'amount-price flex w-full justify-end py-2 font-bold'}>
                  <div className={'amount-price__currency'}>
                    {context.t('Total Price')}: <span
                          className={'text-primary'}>{formatCurrency(currentAmount, paymentCurrency)}</span>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
  );
};

BudgetCart.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  chain: state.bookingFormState.chain,
  cart: state.cart,
}))(BudgetCart);
